export default {
  DATE_FORMAT: "dd.MM.yyyy",
}
